// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"61fe1d2a","453":"ea860244","455":"182c1f6a","977":"6fe6699b"}[chunkId] + ".chunk.js";
};